import { Breadcrumbs, Grid, Link, Typography } from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { Flex } from "~/components/Flex";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

type Props = {
  scope: SpaceOrWorkspaceScope;
  title: string;
};

export const TicketDetailsBreadcrumbs = ({ scope, title }: Props) => {
  const breadcrumbs = [
    <Link
      key="/space/overview"
      component={RouterLink}
      to={`/space/overview?${scope.params}`}
      display="flex"
    >
      <HomeIcon fontSize="inherit" />
    </Link>,
    <Flex gap={1} key="/space/tickets">
      <Link
        component={RouterLink}
        to={`/space/tickets?${scope.params}`}
        display="flex"
      >
        Ticketing
      </Link>
    </Flex>,
    <Typography key="/space/tickets/:mrn">{title}</Typography>,
  ];
  return (
    <Grid size={12}>
      <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
        {breadcrumbs}
      </Breadcrumbs>
    </Grid>
  );
};
